import Heartbeat from './Heartbeat';

export default class EventHeartbeat extends Heartbeat {
  constructor() {
    super( {
      data: {
        action: 'event_heartbeat',
        nonce: window.wp_variables.ajax_nonce,
        post_id: window.wp_variables.current_post_id,
      },
      immediate: false, // Wait at least one interval before the first beat.
    } );

    this.participantCounters = document.getElementsByClassName( 'participants-counter' );

    this.applyButton = document.getElementById( 'event-apply-button' );
    this.applyModalTitle = document.getElementById( 'event-apply-dialog-title' );
    this.hasEventStatusLabel = !! document.getElementById( 'event-status-label' );

    this.responseData = {};

    this.start();
  }

  onSuccess( response ) {
    this.responseData = response.data ?? {};

    if ( ! response.data?.full ) {
      this.hasEventStatusLabel = false;
    }

    if ( ! response.data.enabled ) {
      // Stop the heartbeat since the event is no longer enabled.
      this.applyButton.disabled = true;
      this.stop();
    }
  }

  onFinally() {
    this.updateElements();
  }

  /**
   * Update the HTML based on provided response.
   */
  updateElements() {
    // Set the participant count.
    Array.from( this.participantCounters )?.forEach( el => el.innerText = this.responseData.participants );
    if (!!this.responseData.full) {
      if (this.applyButton) {
        // Set button label.
        this.applyButton.innerText = this.responseData.labels.button;
        if (!this.hasEventStatusLabel) {
          this.createFullLabel( this.applyButton.parentElement, this.responseData.labels.status );
        }
      }
      if (this.applyModalTitle) {
        // Set modal title.
        this.applyModalTitle.innerText = this.responseData.labels.button
      }
    }
  }

  /**
   * Create the full label and prepend it to the given element.
   * @param {HTMLElement} appendTo Element to append the label to.
   * @param {string} label Label to show.
   */
  createFullLabel(appendTo, label) {
    if (!appendTo || !label) {
      return;
    }

    const el = document.createElement( 'div' );
    el.id = 'event-status-label';
    el.className = 'event-hero__status';

    const span = document.createElement( 'span' );
    span.innerText = label;

    let iconHref = null;
    switch (this.responseData.status) {
      case 'applied':
        iconHref = '#icon-check';
        break;

      case 'full':
        iconHref = '#icon-alert';
        break;
    }

    // Output is equal to: <svg class="icon" aria-hidden="true" role="presentation" viewBox="0 0 16 16"><use href="#icon-alert"></use></svg>
    if (!!iconHref) {
      const icon = document.createElement( 'i' );
      icon.className = 'icon';
      icon.role = 'presentation';
      icon.setAttribute( 'aria-hidden', 'true' );

      const use = document.createElement( 'use' );
      use.href = iconHref;
      icon.appendChild( use );

      el.appendChild( icon );
    }

    el.appendChild( span );
    appendTo.appendChild( el );
    appendTo.insertBefore( el, appendTo.firstChild );
  }
}
